import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


const Error404 = ({ link = "/" }) => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(link, { replace: true });
    }, [navigate, link]);

    return (
        <React.Fragment>
        </React.Fragment>
    );
};

export default Error404;